/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as PreviewDataGrid } from './preview-data-grid.story';
export { default as PreviewConfirmationStandalone } from './preview-confirmation-standalone.story';
export { default as PreviewCodeConfirmation } from './preview-code-confirmation.story';
export { default as PreviewCodeLoading } from './preview-code-loading.story';
export { default as PreviewCodeLanguages } from './preview-code-languages.story';
export { default as PreviewSimple } from './preview-simple.story';
export { default as PreviewSimpleWithContent } from './preview-simple-with-content.story';
export { default as PreviewCodeCypher } from './preview-code-cypher.story';
export { default as PreviewCodeTruncation } from './preview-code-truncation.story';

import { removeLicenseHeader } from '../../../_common/export-stories-utils';
import PreviewCodeConfirmationSrcRaw from './preview-code-confirmation.story?raw';
import PreviewCodeCypherSrcRaw from './preview-code-cypher.story?raw';
import PreviewCodeLanguagesSrcRaw from './preview-code-languages.story?raw';
import PreviewCodeLoadingSrcRaw from './preview-code-loading.story?raw';
import PreviewCodeTruncationSrcRaw from './preview-code-truncation.story?raw';
import PreviewConfirmationStandaloneSrcRaw from './preview-confirmation-standalone.story?raw';
import PreviewDataGridSrcRaw from './preview-data-grid.story?raw';
import PreviewSimpleSrcRaw from './preview-simple.story?raw';
import PreviewSimpleWithContentSrcRaw from './preview-simple-with-content.story?raw';

export const PreviewDataGridSrc = removeLicenseHeader(PreviewDataGridSrcRaw);
export const PreviewConfirmationStandaloneSrc = removeLicenseHeader(
  PreviewConfirmationStandaloneSrcRaw,
);
export const PreviewCodeConfirmationSrc = removeLicenseHeader(
  PreviewCodeConfirmationSrcRaw,
);
export const PreviewCodeLoadingSrc = removeLicenseHeader(
  PreviewCodeLoadingSrcRaw,
);
export const PreviewCodeLanguagesSrc = removeLicenseHeader(
  PreviewCodeLanguagesSrcRaw,
);
export const PreviewCodeCypherSrc = removeLicenseHeader(
  PreviewCodeCypherSrcRaw,
);
export const PreviewCodeTruncationSrc = removeLicenseHeader(
  PreviewCodeTruncationSrcRaw,
);
export const PreviewSimpleSrc = removeLicenseHeader(PreviewSimpleSrcRaw);
export const PreviewSimpleWithContentSrc = removeLicenseHeader(
  PreviewSimpleWithContentSrcRaw,
);
